<template>
    <div class="unsubscribe" :style="{ background: '#' + place.color }">
        <div class="unsubscribe-card" v-if="!globalStatus('loading')">
            <img
                class="unsubscribe-logo"
                v-if="place.logo"
                :src="'https://app.kevi.io/' + place.logo"
                :alt="place.name"
            />

            <div class="unsubscribe-body">
                <p class="unsubscribe-text unsubscribe-text--loading" v-if="loading">
                    <span class="unsubscribe-spinner" aria-hidden="true"></span>
                    <span>{{ loadingMessage }}</span>
                </p>

                <p class="unsubscribe-text" v-else>{{ successMessage }}</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.unsubscribe {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.unsubscribe-card {
  width: 100%;
  max-width: 23.125rem;
  padding: 0.75rem 0 0;
  border-radius: 0.25rem;
  background: #ffffff;
  box-shadow: 0 0.1875rem 0.0625rem -0.125rem rgba(0, 0, 0, 0.2),
    0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.14),
    0 0.0625rem 0.3125rem 0 rgba(0, 0, 0, 0.12);
}

.unsubscribe-logo {
  display: block;
  width: 100%;
  max-height: 9.375rem;
  object-fit: contain;
}

.unsubscribe-body {
  padding: 1rem;
}

.unsubscribe-text {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.375rem;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
}

.unsubscribe-text--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  line-height: 1;
}

.unsubscribe-spinner {
  flex: 0 0 auto;
  width: 1.125rem;
  height: 1.125rem;
  border: 0.125rem solid rgba(0, 0, 0, 0.2);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: unsubscribe-spin 0.9s linear infinite;
}

@keyframes unsubscribe-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .unsubscribe-spinner {
    animation-duration: 2.4s;
  }
}
</style>
<script>
import { mapGetters, mapState } from "vuex";
import Api from "../../api";
export default {
    data: () => ({
        clientId: null,
        loading: true,
        unsubscribeType: null,
    }),
    mounted() {
        this.clientId = this.$route.query.client;
        this.unsubscribeType = this.getUnsubscribeType();
        this.loading = true;
        Api.post("client/unsubscribe/" + window.PLACE_SLUG, {
            clientId: this.clientId,
            unsubscribeType: this.unsubscribeType,
        }).then(() => {
            this.loading = false;
        });
    },
    computed: {
        ...mapState({
            place: (state) => state.place,
            client: (state) => state.client,
            token: (state) => state.token,
        }),
        ...mapGetters([
            "globalStatus",
            "clientHasProfileCompleted",
        ]),
        loadingMessage() {
            const messages = {
                general: "Estamos removendo você da nossa lista...",
                email: "Estamos removendo você da nossa lista de e-mails...",
                whatsapp: "Estamos removendo você da nossa lista do WhatsApp...",
                sms: "Estamos removendo você da lista nossa de SMS...",
            };
            return messages[this.unsubscribeType] || messages.general;
        },
        successMessage() {
            const messages = {
                general: "Descadastro realizado com sucesso. Você não receberá mais nenhuma comunicação nossa.",
                email: "Descadastro de e-mail realizado com sucesso. Você não receberá mais nenhuma comunicação nossa via e-mail.",
                whatsapp: "Descadastro do WhatsApp realizado com sucesso. Você não receberá mais nenhuma comunicação nossa via WhatsApp.",
                sms: "Descadastro de SMS realizado com sucesso. Você não receberá mais nenhuma comunicação nossa via SMS.",
            };
            return messages[this.unsubscribeType] || messages.general;
        },
    },
    methods: {
        getUnsubscribeType() {
            const routePath = this.$route.path.replace(/^\//, "");

            if (routePath === "unsubscribe") {
                return "general";
            }

            if (routePath.startsWith("unsubscribe-")) {
                return routePath.replace("unsubscribe-", "");
            }

            return "general";
        },
    },
};
</script>
